import { parseIssaStatus } from "./issaResponseHelpers.ts";

/** What the assistant is busy with, for the icon in her thought bubble. */
export type IssaActivity = "data" | "docs" | "image" | null;

// Worded by InstantAI's status_messages.py: its search and attached-file tools,
// and the verbs it opens a code-analysis status with.
const DOCS = /^(searching|reading attached|connecting (knowledge|the page)|synthesizing|analyzing the attached)/i;
const DATA = /^(analyzing|building|calculating|checking|comparing|computing|converting|counting|creating visualization|detecting|determining|evaluating|examining|filtering|grouping|handling|looking|mapping|interpreting|connecting the patterns|turning the raw|polishing the chart|reviewing|resolving)/i;

/** Null for the generic "Pondering your question..." lines: the bubble then shows dots. */
export function issaActivity(statusText: string | null | undefined): IssaActivity {
  const parsed = parseIssaStatus(statusText);
  if (!parsed) return null;
  if (parsed.kind === "image") return "image";
  if (DOCS.test(parsed.text)) return "docs";
  if (DATA.test(parsed.text)) return "data";
  return null;
}
